var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { CoreConnectionInstance } from "./CoreConnectionInstance.js";
import "../components/physics/Physics.js";
import "../components/types.js";
import "../enums-86f58524.js";
import "../decorators/type.js";
import "ajv";
import "../utils/clone.js";
import "bitecs";
import "../utils/typehelpers.js";
import "../global-33d5eebf.js";
import "../components/ComponentRegistry.js";
import "../utils/byteArray.js";
import "../components/entity/Types.js";
import "@dimforge/rapier2d-compat";
import "../console/flags.js";
import "../persist/persist.js";
import "../console/editor.js";
import "../console/floatingwindow.js";
import "lodash";
import "../Description-c36d0b9a.js";
import "../Attach-abbbd93e.js";
import "../utils/vector.js";
import "../utils/windowSessionStorage.js";
import "pixi.js";
import "../FrameRate-7ce72a03.js";
import "../Collisions-9e9492fb.js";
import "../Physics-8d447f7a.js";
import "../game/GameModel.js";
import "../entity/EntityFactory.js";
import "../constants/index.js";
import "../loader/AssetLoader.js";
import "../loader/ImageLoader.js";
import "../loader/SpriteLoader.js";
import "../loader/PixiSpriteLoader.js";
import "../loader/MapLoader.js";
import "../utils/colors.js";
import "../utils/sharedFetch.js";
import "../vendor/noise/index.js";
import "url";
import "../loader/PixiSpineLoader.js";
import "pixi-spine";
import "../loader/SoundLoader.js";
import "../_commonjsHelpers-7a77ea84.js";
import "toposort";
import "../Parent-b4f1af10.js";
import "../components/core/ListenEntityCreation.js";
import "../Random-b6daba3a.js";
import "../SpatialMap-56228ece.js";
import "../ui/UIService.js";
import "../inputs/InputManager.js";
import "../utils/playSound.js";
import "../utils/md5.js";
import "../TimeDilation-41a74cd7.js";
import "nanoid";
import "../inputs/TouchListener.js";
import "../inputs/PlayerEventManager.js";
import "../game/GameCoordinator.js";
import "pixi-viewport";
import "../game/Ticker.js";
import "../PlayerInput-ad722e2d.js";
class CoopConnectionInstance extends CoreConnectionInstance {
  constructor(inputManager, players, touchRegions) {
    super(
      players.map((player, index) => ({
        netId: "player" + index,
        uniqueId: "player" + index,
        token: "player" + index,
        inputType: player[0],
        inputIndex: player[1],
        config: player[2]
      })),
      inputManager,
      { touchRegions }
    );
    __publicField(this, "playerInputs");
    this.inputManager = inputManager;
    this.touchRegions = touchRegions;
    inputManager.combineKeyMaps = false;
    console.log(this.localPlayers);
    this.localPlayers.forEach((player) => {
      player.connected = true;
    });
  }
  emit(event, ...args) {
    if (event !== "message") {
      if (this.onceSubscriptions[event]) {
        this.onceSubscriptions[event].forEach((callback) => {
          callback(...args);
        });
        this.onceSubscriptions[event] = [];
      }
      if (this.subscriptions[event]) {
        this.subscriptions[event].forEach((callback) => {
          callback(...args);
        });
      }
    }
  }
  connect() {
    for (let i = 0; i < this.localPlayers.length; i++) {
      this.emit("connect", this.localPlayers[i]);
    }
    return Promise.resolve();
  }
}
export {
  CoopConnectionInstance
};
//# sourceMappingURL=CoopConnectionInstance.js.map
